import { render, staticRenderFns } from "./principalMenuItem.vue?vue&type=template&id=2d9d2f13&scoped=true&"
import script from "./principalMenuItem.vue?vue&type=script&lang=js&"
export * from "./principalMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./principalMenuItem.vue?vue&type=style&index=0&id=2d9d2f13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d2f13",
  null
  
)

export default component.exports